import FacebookPageSelect from './FacebookPageSelect';

export default FacebookPageSelect;
